import { DpBenefits } from '@/components/blocks/Benefits';
import { FC } from 'react';

export const DpContentBenefits: FC<{ nocontainer?: boolean }> = ({ nocontainer }) => (
	<DpBenefits nocontainer={nocontainer} />
);
